var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDryEyes = function SvgDryEyes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.749 6c3.067-.045 6.256 2.058 8.254 4.255a1.933 1.933 0 0 1-.002 2.59c-1.952 2.148-5.134 4.3-8.252 4.254-3.119.047-6.3-2.106-8.252-4.257a1.93 1.93 0 0 1 .002-2.59c1.993-2.193 5.183-4.297 8.25-4.251zm.013 1.5c2.662-.044 5.396 1.856 7.129 3.762a.43.43 0 0 1-.002.576c-1.693 1.863-4.419 3.807-7.127 3.76h-.026c-2.708.047-5.433-1.896-7.127-3.762a.43.43 0 0 1 .002-.577C6.34 9.356 9.074 7.456 11.736 7.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.166 11.55a3.42 3.42 0 0 1-2.11 3.156 3.41 3.41 0 0 1-3.723-.741 3.415 3.415 0 0 1 3.724-5.572 3.4 3.4 0 0 1 1.85 1.85c.171.414.26.859.26 1.308zm-1.5 0a1.915 1.915 0 0 1-2.29 1.879 1.917 1.917 0 0 1-1.398-2.613 1.915 1.915 0 0 1 2.505-1.037 1.92 1.92 0 0 1 1.183 1.77zm1.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgDryEyes;